import React from 'react';
import { BadgeDollarSign, Brush, Cpu, Layers, MonitorSmartphone, Wand2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const icons = [Wand2, Cpu, MonitorSmartphone, Layers, BadgeDollarSign, Brush];

const Features = () => {
  const { t } = useLanguage();

  return (
    <section id="features" className="py-24 relative bg-dark">
      <div className="absolute inset-0 opacity-40 pointer-events-none bg-[radial-gradient(ellipse_at_30%_0%,rgba(236,72,153,0.12),transparent_50%)]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-14 max-w-3xl mx-auto">
          <span className="text-accent text-sm font-bold uppercase tracking-[0.2em]">airtisto24</span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-white font-heading leading-tight">
            {t.features.title}
          </h2>
          <p className="mt-4 text-lg text-slate-400 leading-relaxed">{t.features.subtitle}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.features.items.map((item, index) => {
            const Icon = icons[index % icons.length];
            return (
              <div
                key={item.title}
                className="group bg-card-dark border border-border-dark rounded-2xl p-7 hover:border-primary/35 hover:shadow-glow transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-12 h-12 bg-primary/10 border border-primary/20 rounded-xl flex items-center justify-center mb-5 group-hover:bg-primary/20 transition-colors">
                  <Icon className="w-6 h-6 text-primary-light" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2 font-heading">{item.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
